import { tracking } from '@bark/bark-core';

export function creditUpsellModalBindTrackingListeners() {
	const trackingPayload = {
		seller_profile_id: window?.Bark?.seller?.id,
		country_id: window?.Bark?.ENV?.ccid,
		project_id: window?.Bark?.seller?.currentlyShownProjectId,
	};

	if ($('#js-show-cs-subscription-phone-number').length) {
		tracking(
			'credit-subscription-cs-phone-number-credit-modal',
			'number_shown',
			trackingPayload,
		);
	}

	$('#js-show-cs-subscription-phone-number .js-cs-phone-num')
		.off('click.cs-phone')
		.on('click.cs-phone', function () {
			tracking(
				'credit-subscription-cs-phone-number-credit-modal',
				'number_clicked',
				trackingPayload,
			);
		});

	if (!$('#sellerResponseCreditPackUpsell1 .js-card-details-row').hasClass('d-none')) {
		tracking(
			'seller-leads-dashboard-&-responses',
			'credit_pack_credit_cardonfile',
			trackingPayload,
		);
	}

	$('#sellerResponseCreditPackUpsell1 .close-modal-cross')
		.off('click.close-modal')
		.on('click.close-modal', function () {
			tracking(
				'seller-leads-dashboard-&-responses',
				'credit_pack_modal_close',
				trackingPayload,
			);
		});

	$('#sellerResponseCreditPackUpsell1 .credit-pack-row')
		.off('click.credit-pack')
		.on('click.credit-pack', function () {
			const packId = $(this).data('plan-id');
			const nCredits = $(this).data('ncredits');

			tracking('seller-leads-dashboard-&-responses', 'credit_pack_modal_select_pack', {
				...trackingPayload,
				credit_pack_id: packId,
				n_credits: nCredits,
			});
		});

	$('#sellerResponseCreditPackUpsell1 .credit-upsell-topup-submit')
		.off('click.submit-topup')
		.on('click.submit-topup', function () {
			tracking(
				'seller-leads-dashboard-&-responses',
				'credit_pack_modal_topupconfirm',
				trackingPayload,
			);
		});
}
